__turbopack_context__.v({
  "root": "_15sl8W_root",
});
